"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _Title = _interopRequireDefault(require("../../Title"));
var _Card = _interopRequireDefault(require("./Card"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils");
var _Merge = _interopRequireDefault(require("./Merge"));
var _ixdIconsReact = require("@tencent/ixd-icons-react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};

// import Prism from 'prismjs';
// @ts-ignore

function isBrowser() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
/**
 * 元素在中间左侧
 *
 * */
// theme 颜色主题 light dark
// layout 布局方式 horizontal 左右布局  vertical
function Tabs(props) {
  var _a = props || {},
    style = _a.style,
    _b = _a.configuration,
    configuration = _b === void 0 ? [] : _b,
    title = _a.title,
    desc = _a.desc,
    link = _a.link,
    _c = _a.theme,
    theme = _c === void 0 ? 'light' : _c,
    _d = _a.layout,
    layout = _d === void 0 ? 'horizontal' : _d,
    _e = _a.cardConfig,
    cardConfig = _e === void 0 ? [] : _e,
    _f = _a.copySuccessTip,
    copySuccessTip = _f === void 0 ? 'copy success' : _f,
    _g = _a.copyText,
    copyText = _g === void 0 ? 'copy' : _g;
  var _h = link || {},
    txt = _h.txt,
    href = _h.href,
    extendProps = _h.extendProps;
  var _j = (0, _react.useState)(0),
    checked = _j[0],
    setChecked = _j[1];
  var _k = (0, _react.useState)(true),
    flexChild = _k[0],
    setFlexChild = _k[1];
  // const [arr = [], setConfiguration] = useState(configuration) as any;
  var arr = configuration || [];
  var _l = (0, _react.useState)(false),
    showLeft = _l[0],
    setShowLeft = _l[1];
  var _m = (0, _react.useState)(false),
    showRight = _m[0],
    setShowRight = _m[1];
  var handleDome = (0, _react.useRef)();
  var barAnimated = (0, _react.useRef)();
  // 改变左侧控制台
  var changeActionLeft = (0, _react.useCallback)(function (status) {
    setShowLeft(status);
  }, [showLeft]);
  // 改变右侧操作控制台
  var changeActionRight = (0, _react.useCallback)(function (val, status) {
    if (val >= 0) {
      setShowRight(status);
    }
  }, [showRight]);
  var checkedStatus = (0, _react.useCallback)(function (val) {
    setChecked(val);
    // getBoundingClientRect
    var getContainerDome = handleDome.current;
    var getDome = handleDome.current.childNodes[val];
    var containerCountWidth = getContainerDome.scrollWidth || 0;
    var containerHtmlElementClientLeft = getContainerDome === null || getContainerDome === void 0 ? void 0 : getContainerDome.getBoundingClientRect().left;
    var containerHtmlElementClientWidth = getContainerDome === null || getContainerDome === void 0 ? void 0 : getContainerDome.getBoundingClientRect().width;
    var htmlElementClientLeft = getDome === null || getDome === void 0 ? void 0 : getDome.getBoundingClientRect().left;
    var htmlElementClientWidth = getDome === null || getDome === void 0 ? void 0 : getDome.getBoundingClientRect().width;
    var offsetLeft = htmlElementClientLeft - containerHtmlElementClientLeft;
    // const offsetRight = containerCountWidth - offsetLeft; // 距离右侧
    var currentElementPos = containerHtmlElementClientWidth / 2; // 中间点
    var maxDistanceRight = containerCountWidth - containerHtmlElementClientWidth;
    var maxTabWidth = layout === 'horizontal' ? 751 : 1096;
    // 内容宽度不够 flex:1
    if (containerCountWidth > maxTabWidth) {
      // console.log(layout, maxTabWidth);
      if (offsetLeft - currentElementPos >= 0) {
        var toDistance = offsetLeft - currentElementPos + htmlElementClientWidth / 2;
        var val_1 = maxDistanceRight;
        if (toDistance < maxDistanceRight) {
          val_1 = toDistance;
          changeActionRight(maxDistanceRight, true);
        } else {
          changeActionRight(maxDistanceRight, false);
        }
        handleDome.current.style.transform = "translateX(" + -val_1 + "px)";
      } else {
        changeActionRight(maxDistanceRight, true);
        handleDome.current.style.transform = "translateX(0)";
      }
      // 判断是否显示左侧控制台 ---- 元素可视区域距离中间点位置判断
      changeActionLeft(offsetLeft > currentElementPos);
    } else {
      setFlexChild(true);
    }
    // 顶部浮标
    barAnimated.current.style.width = htmlElementClientWidth + "px";
    barAnimated.current.style.left = offsetLeft + "px";
  }, []);
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(function (status) {
      if (status) {
        checkedStatus(0);
      }
    });
  }, []);
  // useEffect(() => {
  //   setConfiguration([...configuration]);
  // }, [configuration]);
  var towards = function towards(status) {
    checkedStatus(status ? (arr === null || arr === void 0 ? void 0 : arr.length) - 1 || 0 : 0);
  };
  return /*#__PURE__*/React.createElement("section", {
    className: 'im-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/React.createElement("section", {
    className: (0, _classnames["default"])('im-container__child', {
      'im-container__vertical_child': layout === 'vertical',
      'im-container__dark_child': theme === 'dark'
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: 'im-desc-content'
  }, title && /*#__PURE__*/React.createElement(_Title["default"], {
    title: title
  }), /*#__PURE__*/React.createElement("div", {
    className: 'im-description'
  }, /*#__PURE__*/React.createElement("p", {
    className: (0, _classnames["default"])('im-desc-p', {
      'im-desc-limit__four': cardConfig.length
    }),
    dangerouslySetInnerHTML: {
      __html: desc || ''
    }
  }), /*#__PURE__*/React.createElement("div", null, txt ? (/*#__PURE__*/React.createElement("a", __assign({
    href: href || '',
    className: 'im-a'
  }, extendProps || {}), txt, /*#__PURE__*/React.createElement(Arrows, null))) : null)), cardConfig.length && layout === 'horizontal' ? (/*#__PURE__*/React.createElement("div", {
    className: 'im-product-card-pc'
  }, /*#__PURE__*/React.createElement(_Card["default"], {
    configuration: cardConfig
  }))) : null), /*#__PURE__*/React.createElement("div", {
    className: 'im-merge-container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'im-merge-container--pc'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'im-tabs'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'im-tabs-one'
  }, /*#__PURE__*/React.createElement("div", {
    onClick: towards.bind(null, false),
    className: (0, _classnames["default"])('im-container__child__action left', {
      'bar-animation': showLeft
    })
  }, /*#__PURE__*/React.createElement(Svg, null)), /*#__PURE__*/React.createElement("div", {
    className: 'im-ul',
    ref: handleDome,
    style: {
      transform: 'translateX(0)'
    }
  }, arr ? arr.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames["default"])('im-tabs-tab', {
        'im-tabs-tab-active': checked === index,
        'im-tabs-tab-flex': flexChild
      }),
      onClick: checkedStatus.bind(null, index),
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: 'div'
    }, item.label || ''));
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "im-bar-animated",
    ref: barAnimated
  })), /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames["default"])('im-container__child__action right', {
      'bar-animation': showRight
    }),
    onClick: towards.bind(null, true)
  }, /*#__PURE__*/React.createElement(Svg, null))), /*#__PURE__*/React.createElement("div", {
    className: 'im-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames["default"])('im-content--extends', {
      'im-content--extends--show': !!(arr ? arr.length > 0 : 0)
    })
  }, arr ? arr.map(function (items, index) {
    return /*#__PURE__*/React.createElement(Content, {
      key: index,
      index: index,
      record: items,
      checked: checked,
      copySuccessTip: copySuccessTip,
      copyText: copyText,
      layout: layout
    });
  }) : null)))), /*#__PURE__*/React.createElement("div", {
    className: 'im-merge-container--mo'
  }, /*#__PURE__*/React.createElement(_Merge["default"], {
    configuration: arr,
    onCallBack: function onCallBack(val) {
      setChecked(val);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: 'im-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'im-content--extends'
  }, arr ? arr.map(function (items, index) {
    return /*#__PURE__*/React.createElement(Content, {
      key: index,
      index: index,
      record: items,
      checked: checked,
      copySuccessTip: copySuccessTip,
      copyText: copyText,
      layout: layout
    });
  }) : null)))), cardConfig.length && layout === 'horizontal' ? (/*#__PURE__*/React.createElement("div", {
    className: 'im-product-card-mobile'
  }, /*#__PURE__*/React.createElement(_Card["default"], {
    configuration: cardConfig
  }))) : null));
}
var Svg = function Svg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "12",
    viewBox: "0 0 8 12",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99991 0.292908L0.585693 1.70712L4.87859 6.00001L0.585693 10.2929L1.99991 11.7071L7.70701 6.00001L1.99991 0.292908Z",
    fill: "black"
  }));
};
var Arrows = function Arrows() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "12",
    viewBox: "0 0 15 12",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.48679L8.58871 0L15 6L8.58871 12L7 10.5132L10.8921 7H0V5H10.8921L7 1.48679Z",
    fill: "#006EFF"
  }));
};
Tabs.TabPane = Tabs;
var _default = exports["default"] = Tabs;
function codeColoring(text) {
  var code = [{
    search: / /g,
    replace: ' '
  },
  // { search: /\n/g, replace: '<br />' },
  // { search: /[^a-z:]\/\/[\s]*([a-zA-Z0-9$().;:&,=' ]{1,})/g, replace: '<span class="gray">//$1</span>' },
  // { search: /\bvar\b/g, replace: '<span class="blue">var</span>' },
  // { search: /\belse\b/g, replace: '<span class="blue">else</span>' },
  // { search: /\btrue\b/g, replace: '<span class="blue">true</span>' },
  // { search: /\bfalse\b/g, replace: '<span class="blue">false</span>' },
  // { search: /\barray\b/g, replace: '<span class="blue">array</span>' },
  // { search: /\bfunction\b/g, replace: '<span class="blue">function</span>' },
  // { search: /[^$]\bthis\b/g, replace: '<span class="yellow">this</span>' },
  // { search: /\breturn\b/g, replace: '<span class="blue">return</span>' },
  // { search: /\bfor\b/g, replace: '<span class="blue">for</span>' },
  // { search: /\bforeach\b/g, replace: '<span class="blue">foreach</span>' },
  // { search: /\bwhile\b/g, replace: '<span class="blue">while</span>' },
  // { search: /\bas\b/g, replace: '<span class="blue">as</span>' },
  // { search: /\$([a-z]{1,})/g, replace: '<span class="green">$$1</span>' },
  // { search: /[^:a-z]([0-9]{1,})/g, replace: '<span class="red">$1</span>' },
  {
    search: /(\(<\/span>)([\w]{1,})(<span class="token){1}/g,
    replace: '(</span><span class="params-one">$2</span><span class="' + ''
  }, {
    search: /(class-name">.+<span class="token punctuation">\.<\/span>)([\w]{1,})(<\/span>){1}/g,
    replace: '$1<span class="constructor-function">$2</span>$3'
  }];
  for (var i = 0; i < code.length; i++) {
    text = text.replace(code[i].search, code[i].replace);
  }
  return text;
}
function Content(props) {
  var record = props.record,
    checked = props.checked,
    index = props.index,
    copySuccessTip = props.copySuccessTip,
    copyText = props.copyText,
    _a = props.layout,
    layout = _a === void 0 ? 'horizontal' : _a;
  var _b = (record || {}).code,
    code = _b === void 0 ? '' : _b;
  var _c = (0, _react.useState)(),
    html = _c[0],
    setHtml = _c[1];
  var _d = (0, _react.useState)(false),
    showTip = _d[0],
    setShowTip = _d[1];
  var _e = (0, _react.useState)(false),
    showMessage = _e[0],
    setShowMessage = _e[1];
  var _f = (0, _react.useState)([]),
    codeHeight = _f[0],
    setCodeHeight = _f[1];
  var contentRef = (0, _react.useRef)({});
  var tabsContent = (0, _react.useRef)({});
  var copyCode = function copyCode(text) {
    if (!isBrowser()) {
      return null;
    }
    if ('clipboard' in navigator) {
      return navigator.clipboard.writeText(text);
    }
    return document.execCommand('copy', true, text);
  };
  (0, _react.useEffect)(function () {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    var Prism = require('prismjs');
    var html = codeColoring(Prism.highlight(code, Prism.languages.javascript, 'javascript'));
    setHtml(html);
    (0, _utils.windowAddEventListener)(function (status) {
      var preNode = contentRef.current;
      var captureHeight = !preNode ? 0 : (preNode === null || preNode === void 0 ? void 0 : preNode.clientHeight) || 0;
      var captureLength = Math.floor(captureHeight / 28);
      var maxSpan = status ? 1 : 10;
      if (layout === 'horizontal' && captureLength < 12) {
        captureLength = 12;
      } else if (layout === 'vertical' && captureLength < 15) {
        captureLength = 15;
      }
      var captureArr = new Array(captureLength < maxSpan ? maxSpan : captureLength).fill(1);
      setCodeHeight(captureArr);
      if (status) {
        addOnMouseOver();
      }
    }, 1);
  }, [html, checked]);
  var addOnMouseOver = function addOnMouseOver() {
    if (!(tabsContent === null || tabsContent === void 0 ? void 0 : tabsContent.current)) return true;
    tabsContent.current.onmouseover = function () {
      // this.click();
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames["default"])('im-content__list im-code-edit', {
      'im-content__list--show': checked === index
    }),
    key: index
  }, code ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "tabs-content line-numbers",
    ref: tabsContent
  }, /*#__PURE__*/React.createElement("pre", {
    className: (0, _classnames["default"])('content active line-numbers language-swift', {
      'horizontal-pre': layout === 'horizontal'
    })
  }, /*#__PURE__*/React.createElement("div", {
    ref: contentRef,
    id: "im-tabVertContent-1",
    dangerouslySetInnerHTML: {
      __html: html
    }
  }), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: "line-numbers-rows"
  }, codeHeight.map(function (_item, index) {
    return /*#__PURE__*/React.createElement("span", {
      key: index
    });
  })))), /*#__PURE__*/React.createElement("div", {
    className: "im-copy-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "im-copy-article"
  }, /*#__PURE__*/React.createElement("em", {
    className: (0, _classnames["default"])('im-copy-tips', {
      'im-copy-tips__show': showTip
    })
  }, copyText), /*#__PURE__*/React.createElement("i", {
    className: (0, _classnames["default"])('im-copy-success', {
      'im-copy-success__show': showMessage
    })
  }, /*#__PURE__*/React.createElement(_ixdIconsReact.SuccessIcon, null), copySuccessTip), /*#__PURE__*/React.createElement("svg", {
    className: 'im-code-copy',
    onClick: function onClick() {
      var timer = 0;
      clearTimeout(timer);
      setShowTip(false);
      setShowMessage(true);
      copyCode(code);
      timer = window.setTimeout(function () {
        setShowMessage(false);
      }, 1500);
    },
    onMouseEnter: function onMouseEnter() {
      setShowTip(!showMessage);
    },
    onMouseLeave: function onMouseLeave() {
      setShowTip(false);
    },
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "40",
    rx: "4",
    fill: "black",
    fillOpacity: "0.3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 12H28V25H26V14H15V12H26H27ZM25 15H12V28H25V15ZM14 26V17H23V26H14Z",
    fill: "white"
  })))))) : null);
}